import React from "react";

const ProfileOscar = () => {
  return (
    <div className="icon-container">
      <figure className="effect-oscar">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FHome%2FperfilPortafolio.png?alt=media&token=45ea57b5-55eb-4bbf-a4ee-8c7353ada542"
          alt="iMy profile"
          width={"130px"} 
          height={"130px"} 
        />
      </figure>
    </div>
  );
};

export default ProfileOscar;
